const vn = {
  switchOrg: 'Chuyển đổi tổ chức thành công! Đang làm mới trang cho bạn...',
  userInfo: 'thông tin cá nhân',
  preferences: 'Thiết lập hệ thống',
  logout: 'đăng xuất',
  invnManag: 'Quản lý kho',
  orgHouse: 'Kho tổ chức',
  orderList: 'Danh sách đặt hàng',
  invnHistory: 'Kiểm kê lịch sử',
  salesMana: "quản lý bán hàng",
  orgManag: 'Quản lý tổ chức',
  customMana: "Quản lý khách hàng cuối",
  bomMana: 'Quản lý BOM',
  priceMana: "Quản lý giá",
  orderMana: "Quản lý đơn hàng",
  memberManag: 'Quản lý thành viên',
  enableMember: 'Cho phép thành viên',
  disableMember: 'Vô hiệu hóa thành viên',
  categoryManag: 'Quản lý danh mục sản phẩm',
  productList: 'Danh sách sản phẩm',
  aPPManagement: 'Quản lý APP',
  productData: 'Nhập dữ liệu sản xuất',
  orderReviews: 'Đánh giá đơn hàng',
  productionInfo: 'Tạo tài liệu sản xuất',
  dataModule: 'mô-đun dữ liệu',
  orderReport: 'Báo cáo đơn hàng',
  conLogout: 'Bạn có chắc bạn muốn thoát?',
  conLogoutTip1: 'Sau khi xác nhận đăng xuất, bạn sẽ quay lại trang đăng nhập.',
  loggingOut: 'Đang đăng xuất bạn...',
  selectOrg: 'Vui lòng chọn một tổ chức',
  themeColor: 'Màu chủ đề',
  addSuccess: 'Thêm thành công',
  addFailed: 'thêm thất bại',
  updateSuccess: 'hoàn thành cập nhật',
  updateFailed: 'Cập nhật không thành công',
  validaFailed: 'Xác minh không hoàn thành',
  cancel: 'Hủy bỏ',
  confirm: 'Chắc chắn',
  Loading: 'đang tải',
  upFail: 'Tải lên không thành công',
  plTryAgain: 'Vui lòng thử lại sau',
  changeTip: 'Thiết lập ngôn ngữ',
  switchOrgFailTip1: 'Tổ chức hiện tại không có quyền và không thể chuyển đổi!',
  switchOrgFailTip2: 'Chuyển đổi tổ chức thất bại, hãy thử lại!',
  loginFailTip1: 'Tài khoản không phải là người quản trị nền, vui lòng quay lại đăng nhập người dùng.',
  loginFailTip2: 'Tài khoản này không tham gia vào tổ chức hoặc không có quyền, vui lòng liên hệ với người quản trị.',
  userAbnormalTip: 'Trạng thái người dùng bất thường hoặc không đủ quyền, liên hệ với quản trị viên hoặc đăng nhập lại!',
  orderProductionReports: 'Báo cáo sản xuất đơn đặt hàng',
  orderReview: 'Đánh giá đơn hàng',
  orderProductionData: 'Dữ liệu sản xuất đơn đặt hàng',
  purchaseMana: 'Quản lý mua sắm',
  supplierMana: 'Quản lý nhà cung cấp',
  materialControl: 'Quản lý vật liệu',
  requirementList: ' Danh sách yêu cầu',
  noPassRequirement: ' Danh sách các yêu cầu chưa được phê duyệt',
  passedRequirement: ' Danh sách các yêu cầu đã được phê duyệt',
  prod: 'Quản lý sản xuất',
  finance: 'Quản lý tài chính',
  generatePurOrder: 'Tạo đơn đặt hàng mua hàng',
  isAdmin: 'Quản trị hệ thống',

  okOrder: 'Đơn đặt hàng chính thức',
  saleOrderFinish: 'Kết thúc đơn hàng bán',
  waitOk: 'Đánh giá nhu cầu',
  noPass: 'Đánh giá đang chờ xử lý',
  passed: 'requirements đã được review',
  purOrder: ' Quản lý đơn đặt hàng',
  orderRe: 'Bảng đánh giá bán hàng',
  disableAndEnable: 'Vô hiệu hóa và kích hoạt',
  memberOperation: 'Hoạt động thành viênHoạt động thành viên',
  commodityEditor: 'Biên tập hàng hóa',
  subcategoryEditing: 'Sự soạn thảo tiểu hạng',
  orgOperation: 'Tổ chức hoạt động',
  reject: 'Yêu cầu trả lại',
  orgMana: "Quản lý tổ chức",
  orgInfoUpdate: "Sửa đổi thông tin tổ chức",
  orgMemberUpdate: "Sửa đổi thành viên tổ chức",
  wareMana: "Quản lý kho",
  inboundMana: "Quản lý đầu vào",
  outboundMana: "Quản lý Outbound",
  inventoryMana: "Quản lý hàng tồn kho",
  orderTrack: 'Theo dõi đơn đặt hàng',
  pendingOrder: 'Chưa hoàn thành',
  doneOrder: 'Đã hoàn thành',
  closeOrder: 'Đóng cửa',
  mcDataMt: ' Bảo trì dữ liệu kiểm soát',
  mcReTemp: ' Mẫu điều khiển vật lý',
  orderEntry: ' Nhập dữ liệu đơn đặt hàng',
  orderProdMt: ' Bảo trì dữ liệu sản xuất',
  purPendingPay: ' Không đặt hàng',
  purPayed: ' Đã đặt hàng',
  purDone: ' Đã hoàn thành',
  purOrderMt: 'Bảo trì thông tin mua hàng',
  requirementPurchase: 'Lập đơn mua hàng',
  reqM: 'Kế hoạch chuẩn bị vật tư',
  DATAManage: "Quản lý dữ liệu",
  QutationManage: 'Quản lý yêu cầu',
  typeManage: 'Quản lý loại hàng hóa',
  submit: 'Lưu',
  gategoryManage: 'Danh sách hàng hóa báo giá',
  printSetting: 'Thiết lập in',
  quotationManage: 'Quản lý báo giá',
  setExchange: 'Đặt tỷ giá hối đoái',
  mainCurrency: 'Tiền bản vị',
  company: 'Tên công ty',
  address: 'Địa chỉ công ty',
  plzCompany: 'Vui lòng nhập tên công ty',
  plzAddress: 'Vui lòng nhập địa chỉ công ty',
  orderManage: 'Quản lý đơn hàng',
  warehousePreparation: 'Chuẩn bị nhập/xuất kho',
  warehouseManagement: 'Quản lý nhập/xuất kho',
  operationStatus: 'Trạng thái hoạt động',
  locationManagement: 'Quản lý vị trí',
  commodity: 'Quản lý sản phẩm',
  upSucc: "Tải lên tệp thành công",
  addressM: "Quản lý địa chỉ giao hàng",
  addAddress: "Thêm địa chỉ",
  editAddress: "Sửa địa chỉ",
  inventoryManage: "Quản lý kho",
  purchaseOperation: 'Hoạt động mua hàng',
  manualQuotation: 'Báo giá thủ công',
  materialTracking: 'Theo dõi vật liệu',
  returnAndExchange: 'Trả hàng và đổi hàng',
  pleaseFillRate: 'Vui lòng điền tỷ giá hối đoái',
  uploadImage: 'Tải lên hình ảnh',
  pleaseEnterName: 'Vui lòng nhập tên',
  pleaseEnterAddress: 'Vui lòng nhập địa chỉ',
  orderReportAll: 'Báo cáo đơn hàng_Tất cả',
  // Quản lý nhà cung cấp
  disabledSupplier: 'Nhà cung cấp đã bị vô hiệu hóa',
  confirmDisableSupplier: 'Xác nhận vô hiệu hóa?',
  confirmDisableSupplierDesc: 'Điều này sẽ vô hiệu hóa nhà cung cấp này',
  confirmEnableSupplier: 'Xác nhận kích hoạt?',
  confirmEnableSupplierDesc: 'Điều này sẽ kích hoạt nhà cung cấp này',


  // Reimburse
  reimburseMana: 'Phê duyệt đơn',
  myApplication: 'Đơn đăng ký của tôi',
  pendingApproval: 'Chờ phê duyệt của tôi',
  allApplications: 'Tất cả đơn đăng ký',
  inOutDetail: 'Chi tiết nhập/xuất kho',
  locationRefProducts: 'Quan hệ sản phẩm vị trí',
  priceList: "Danh sách giá mua hàng",
  inventoryAlert: "Cảnh báo tồn kho",
  setInventoryAlert: "Thêm cảnh báo tồn kho",
  purchaseRule: "Điều khoản mua hàng",
  addPurchaseRule: "Thêm điều khoản mua hàng",
  ruleLangsPl: "Vui lòng chọn ngôn ngữ cho điều khoản mua hàng cần thêm (nếu không có ngôn ngữ bạn muốn, vui lòng vào cài đặt hệ thống để bổ sung)",
  printRule: "Thêm điều khoản",
  notPrintRule: "Không thêm điều khoản",
  noRuleConfig: "Chưa có điều khoản mua hàng cho bất kỳ ngôn ngữ nào. Để in điều khoản mua hàng, vui lòng hoàn thiện trong cài đặt hệ thống.",
  purchaseRuleSet: "Cài đặt điều khoản mua hàng",
  factoryInventory: "Kho dây chuyền sản xuất",
  equipmentManagement: "Quản lý thiết bị",
  width: "Chiều rộng giấy (liên tục dọc)",
  height: "Chiều cao giấy (liên tục dọc)",
  printTip: "Cài đặt giấy in hệ thống: {{width}}mm X {{height}}mm",
  printTipVertical: "Cài đặt giấy in liên tục dọc (Rộng X Cao)",
  purInvItem: "Chi tiết phiếu giao hàng",
  locInvDetail: "Chi tiết nhập/xuất kho theo vị trí",
};

export default vn;
